import React from 'react';
import PropTypes from 'prop-types';
import { isObject } from 'lodash';

import TextField from '../../TextField/TextField';
import { isEmptyOperator } from './utils';

const style = {
  root: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    height: 85,
    width: 250,
    marginRight: 10,
  },
};

export class ValueEditorChargerComponent extends React.Component {
  static getDerivedStateFromProps(props) {
    if (!isObject(props.value)) {
      props.onChange({
        name: '',
        version: '',
      });
    } else {
      const value = {
        name: props.value.name,
        version: props.value.version,
      };

      if (isEmptyOperator(props.operator.name)) {
        value.name = '';
      }

      if (isEmptyOperator(props.operator.version)) {
        value.version = '';
      }

      if (value.name !== props.value.name || value.version !== props.value.version) {
        props.onChange(value);
      }
    }

    return null;
  }

  state = {};

  onNameChange = (event) => {
    this.props.onChange({
      name: event.target.value,
      version: this.props.value.version || '',
    });
  };

  onVersionChange = (event) => {
    this.props.onChange({
      name: this.props.value.name || '',
      version: event.target.value,
    });
  };

  render() {
    const { operator } = this.props;

    return (
      <div style={style.root} className="query-builder-value-charger-component">
        <TextField
          value={this.props.value.name || ''}
          style={this.props.style}
          onChange={this.onNameChange}
          disabled={isEmptyOperator(operator.name)}
          className="charger-package__field"
        />
        <TextField
          value={this.props.value.version || ''}
          style={this.props.style}
          onChange={this.onVersionChange}
          disabled={isEmptyOperator(operator.version)}
          className="charger-package__field"
        />
      </div>
    );
  }
}

ValueEditorChargerComponent.propTypes = {
  value: PropTypes.any,
  style: PropTypes.object,
  onChange: PropTypes.func,
};
